// extracted by mini-css-extract-plugin
export default {"buttonIcon":"ButtonQuestionPoll_buttonIcon__qziKu"};